import { render, staticRenderFns } from "./tenantThree.vue?vue&type=template&id=2ffae8a6"
import script from "./tenantThree.vue?vue&type=script&lang=js"
export * from "./tenantThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports